import { Component, OnInit, ViewChild } from '@angular/core';
import { Ocorrencia } from '../models/ocorrencia';
import { Funcionario } from '../models/funcionario';
import { OcorrenciaTipo } from '../models/ocorrencia-tipo';
import { CarregandoService } from '../services/carregando.service';
import { NotificacaoService } from '../services/notificacao.service';
import { OcorrenciaService } from '../services/ocorrencia.service';
import { OcorrenciaTipoService } from '../services/ocorrencia-tipo.service';
import { Router } from '@angular/router';
import { MatDialog, PageEvent, MatPaginator } from '@angular/material';
import { GlobalService } from '../services/global.service';
import { UtilitarioService } from '../services/utilitario.service';
import { FuncionarioService } from '../services/funcionario.service';
import { OcorrenciaTipoModalComponent } from '../modals/ocorrencia-tipo-modal/ocorrencia-tipo-modal.component';
import { ClienteService } from '../services/cliente.service';
import { Cliente } from '../models/cliente';
import { ClientesModalComponent } from '../modals/clientes-modal/clientes-modal.component';
import { UsuarioLogado } from '../models/usuario-logado';
import { Fornecedor } from '../models/fornecedor';
import { FornecedorService } from '../services/fornecedor.service';
import { PremissasService } from '../services/premissas.service';
import { Setor } from '../models/setor';
import { SetorService } from '../services/setor.service';
import { NotaFiscalPedidoModalComponent } from '../modals/nota-fiscal-pedido-modal/nota-fiscal-pedido-modal.component';
import { NotaFiscalService } from '../services/nota-fiscal.service';
import { CRMHierarquiaUsuario } from '../models/crmhierarquia-usuario';
import { CRMHierarquiaUsuarioService } from '../services/crmhierarquia-usuario.service';
import { PaginatorService } from '../services/paginator.service';
import { EtapaOcorrencia } from '../models/etapa-ocorrencia';

declare const $: any;

@Component({
  selector: "app-controle-ocorrencia",
  templateUrl: "./controle-ocorrencia.component.html",
  styleUrls: ["./controle-ocorrencia.component.scss"],
})
export class ControleOcorrenciaComponent implements OnInit {
  fornecedores: Fornecedor[] = [];
  multiFornecedores = false;
  pCentroDistribuicao = false;

  periodos = [
    { id: 0, name: "Todos" },
    { id: 1, name: "Mês Atual" },
    { id: 2, name: "Mês Passado" },
    { id: 3, name: "Personalizado" },
    { id: 4, name: "Hoje" },
    { id: 5, name: "Ontem" },
    { id: 6, name: "Semana" },
    { id: 7, name: "Últimos 3 Meses" },
    { id: 8, name: "Últimos 6 Meses" },
    { id: 9, name: "Ano Atual" },
  ];

  enumStatus = [
    { id: 0, name: "Novo" },
    { id: 1, name: "Em Andamento" },
    { id: 2, name: "Concluido" },
  ];

  prioridades = [
    { id: 0, descricao: "Sem Prioridade", cor: "#6c757d" },
    { id: 1, descricao: "Baixa", cor: "#198754" },
    { id: 2, descricao: "Média", cor: "#ffc107" },
    { id: 3, descricao: "Alta", cor: "#dc3545" },
  ];

  ocorrencias: Ocorrencia[] = [];
  funcionarios: CRMHierarquiaUsuario[] = [];
  clientes: Cliente[] = [];
  ocorrenciatipo: OcorrenciaTipo[] = [];
  paginacao;
  filtroOcorrencia = {
    idCupom: "",
    idOcorrencia: "",
    periodoSelecionado: 0,
    funcionarioSelecionado: undefined,
    vendedorSelecionado: undefined,
    integradorSelecionado: undefined,
    tipoSelecionado: undefined,
    pedidoSelecionado: undefined,
    campoOrdenacao: "id",
    ordenarDesc: false,
    itensPorPagina: 10,
    statusSelecionados: [],
    pInicio: undefined,
    pFim: undefined,
    idFornecedor: undefined,
    setorSelecionado: undefined,
    notaFiscal: undefined,
    prioridade: undefined,
    etapaOcorrencia: undefined,
  };

  listaDeItensPorPagina;
  verExcel = false;

  setores: Setor[] = [];
  etapasOcorrencia: EtapaOcorrencia[] = [];

  @ViewChild("paginator", { static: false }) paginator: MatPaginator;

  usuarioLogado: UsuarioLogado;

  administrador = false;
  constructor(
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private ocorrenciaService: OcorrenciaService,
    private ocorrenciaTipoService: OcorrenciaTipoService,
    private funcionarioService: FuncionarioService,
    private router: Router,
    public dialog: MatDialog,
    private globalService: GlobalService,
    private utilitarioService: UtilitarioService,
    private clienteService: ClienteService,
    private fornecedorService: FornecedorService,
    private premissasService: PremissasService,
    private setorService: SetorService,
    private notaFiscalService: NotaFiscalService,
    private hierarquiaService: CRMHierarquiaUsuarioService,
    private paginatorService: PaginatorService
  ) {}

  async ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.filtroOcorrencia.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.usuarioLogado = await this.globalService.consultaUsuario();
    this.administrador = await this.globalService.administrador();

    if (localStorage.getItem("filtroOcorrencia") !== null) {
      this.filtroOcorrencia = JSON.parse(localStorage.getItem("filtroOcorrencia"));
    }

    this.filtroOcorrencia.statusSelecionados = [0, 1];

    this.buscarMultiFornecedores();
    this.buscarFornecedores();
    this.buscarSetores();
    this.buscarOcorrencias();
    this.buscarFuncionarios();
    this.buscarClientes();
    await this.buscarPremissaCentroDeDistribuicao();
    this.buscarEtapasOcorrencia();
    this.verExcel = this.usuarioLogado.verExcel;
  }

  async buscarPremissaCentroDeDistribuicao() {
    try {
      this.pCentroDistribuicao = (await this.premissasService.consultarCentroDeDistribuicao().toPromise()).valor;
      if (this.pCentroDistribuicao) {
        await this.buscarIdCDPadrao();
      }
    } catch (erro) {
      this.notificacaoService.erro(erro);
    }
  }

  async buscarIdCDPadrao() {
    try {
      const idCDPadrao = await this.funcionarioService.consultarIdCDPadrao().toPromise();
      if (idCDPadrao !== null && idCDPadrao !== undefined) {
        this.filtroOcorrencia.idFornecedor = idCDPadrao;
      }
    } catch (erro) {
      this.notificacaoService.erro(erro);
    }
  }

  definePeriodo() {
    if (this.filtroOcorrencia.periodoSelecionado !== 3) {
      this.filtroOcorrencia.pInicio = undefined;
      this.filtroOcorrencia.pFim = undefined;

      this.buscarOcorrencias();
    } else {
      if (this.filtroOcorrencia.pInicio && this.filtroOcorrencia.pFim) {
        this.buscarOcorrencias();
      }
    }
  }

  ordena(campo: string) {
    if (campo) {
      this.filtroOcorrencia.campoOrdenacao = campo;
      this.filtroOcorrencia.ordenarDesc = !this.filtroOcorrencia.ordenarDesc;

      this.mudaDePagina({
        length: this.paginator.length,
        pageIndex: this.paginator.pageIndex,
        pageSize: this.paginator.pageSize,
      });
    }

    return false;
  }

  buscarFornecedores() {
    this.fornecedorService.consultarFornecedores().subscribe(
      (forn) => {
        this.fornecedores = forn;
      },
      (err) => {
        this.notificacaoService.erro(err);
      }
    );
  }

  buscarMultiFornecedores() {
    this.premissasService.consultarMultiFornecedores().subscribe(
      (f) => {
        this.multiFornecedores = f.valor;
      },
      (erro) => {
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarClientes() {
    this.carregandoService.mostra("buscarClientes");
    this.filtroOcorrencia.integradorSelecionado = undefined;
    this.clienteService
      .consultarClientesDoVendedor(
        this.filtroOcorrencia.funcionarioSelecionado === 0
          ? undefined
          : this.filtroOcorrencia.funcionarioSelecionado === -1
          ? this.usuarioLogado.id
          : this.filtroOcorrencia.funcionarioSelecionado
      )
      .subscribe(
        (resp) => {
          this.clientes = resp;
          const todos = new Cliente();
          todos.id = undefined;
          todos.nome = "Todos";
          this.clientes.unshift(todos);

          this.carregandoService.esconde("buscarClientes");
        },
        (erro) => {
          this.carregandoService.esconde("buscarClientes");
          this.notificacaoService.erro(erro);
        }
      );
  }

  pesquisarCliente() {
    const dialogRef = this.dialog.open(ClientesModalComponent, {
      width: $("body").width().toString() + "px",
      data: {
        gi: 1,
        esconderBotao: true,
        pesquisarPorVendedor: true,
        idVendedor:
          this.filtroOcorrencia.funcionarioSelecionado === -1
            ? this.usuarioLogado.id
            : this.filtroOcorrencia.funcionarioSelecionado,
      },
      panelClass: "modal-card",
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.filtroOcorrencia.integradorSelecionado = result.cliente.id;
      }
    });
  }

  retornaClasseStatus(status: number) {
    switch (status.toString()) {
      case "0":
        return "badge-primary";
      case "1":
        return "badge-info";
      case "2":
        return "badge-success";

      default:
        return "badge-info";
    }
  }

  retornaClasseTipoOcorrencia(tipo: number) {
    switch (tipo.toString()) {
      case "0":
        return "badge-secondary";
      case "1":
        return "badge-success";
      case "2":
        return "badge-warning";
      case "3":
        return "badge-danger";

      default:
        return "badge-info";
    }
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.filtroOcorrencia.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.filtroOcorrencia.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarOcorrencias(true);
  }

  buscarFuncionarios() {
    this.carregandoService.mostra("buscarFuncionarios");
    this.funcionarioService.consultarTodosFuncionarios().subscribe(
      (funcionarios: Funcionario[]) => {
        this.funcionarios = funcionarios.map((p) => ({ idFuncion: Number(p.idFuncion), nome: p.nome }));
        if (this.funcionarios.length > 1) {
          this.funcionarios.unshift({ idFuncion: 0, nome: "Todos" });
        }
        this.carregandoService.esconde("buscarFuncionarios");
      },
      (err: Error) => {
        this.carregandoService.esconde("buscarFuncionarios");
        this.notificacaoService.erro(err);
      }
    );
  }

  buscarOcorrenciaTipo(buscarOcorrencias?) {
    this.carregandoService.mostra("buscarOcorrenciaTipo");

    if (this.filtroOcorrencia.setorSelecionado === null || this.filtroOcorrencia.setorSelecionado === undefined) {
      this.ocorrenciaTipoService.consultarTodosOcorrenciaTipo().subscribe(
        (ocorrenciatipo: OcorrenciaTipo[]) => {
          this.ocorrenciatipo = ocorrenciatipo;
          this.carregandoService.esconde("buscarOcorrenciaTipo");

          this.filtroOcorrencia.tipoSelecionado = undefined;

          if (buscarOcorrencias) {
            this.buscarOcorrencias();
          }
        },
        (err: Error) => {
          this.carregandoService.esconde("buscarOcorrenciaTipo");
          this.notificacaoService.erro(err);
        }
      );
    } else {
      this.ocorrenciaTipoService.consultarPorIdSetor(this.filtroOcorrencia.setorSelecionado).subscribe(
        (ocorrenciatipo: OcorrenciaTipo[]) => {
          this.ocorrenciatipo = ocorrenciatipo;
          this.carregandoService.esconde("buscarOcorrenciaTipo");

          this.filtroOcorrencia.tipoSelecionado = undefined;

          if (buscarOcorrencias) {
            this.buscarOcorrencias();
          }
        },
        (err: Error) => {
          this.carregandoService.esconde("buscarOcorrenciaTipo");
          this.notificacaoService.erro(err);
        }
      );
    }
  }

  buscarSetores() {
    this.carregandoService.mostra("buscarSetores");

    this.setorService.consultarSetores().subscribe(
      (data: any) => {
        this.setores = data;

        if (
          this.filtroOcorrencia.setorSelecionado !== null &&
          this.filtroOcorrencia.setorSelecionado !== undefined &&
          !this.setores.some((p) => p.id === this.filtroOcorrencia.setorSelecionado)
        ) {
          this.filtroOcorrencia.setorSelecionado = null;
        }

        this.buscarOcorrenciaTipo();

        this.carregandoService.esconde("buscarSetores");
      },
      (erro) => {
        this.carregandoService.esconde("buscarSetores");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarEtapasOcorrencia() {
    this.carregandoService.mostra("buscarEtapasOcorrencia");
    this.ocorrenciaService
      .consultarEtapas(this.filtroOcorrencia.setorSelecionado, this.filtroOcorrencia.tipoSelecionado)
      .subscribe(
        (data: any) => {
          this.etapasOcorrencia = data;
          this.carregandoService.esconde("buscarEtapasOcorrencia");
        },
        (erro) => {
          this.carregandoService.esconde("buscarEtapasOcorrencia");
          this.notificacaoService.erro(erro);
        }
      );
  }

  buscarOcorrencias(seguirPaginacao?) {
    if (!seguirPaginacao) {
      this.paginator.firstPage();
      this.paginacao.paginaAtual = 1;
      this.paginacao.total = 0;
    }

    localStorage.setItem("filtroOcorrencia", JSON.stringify(this.filtroOcorrencia));

    this.carregandoService.mostra("buscarOcorrencias");

    this.ocorrenciaService
      .consultarComPaginacao(
        this.paginacao.paginaAtual,
        this.filtroOcorrencia.itensPorPagina,
        this.filtroOcorrencia.campoOrdenacao,
        this.filtroOcorrencia.ordenarDesc ? "desc" : "asc",
        this.filtroOcorrencia.idCupom,
        this.filtroOcorrencia.periodoSelecionado,
        this.filtroOcorrencia.statusSelecionados,
        this.filtroOcorrencia.funcionarioSelecionado === 0
          ? undefined
          : this.filtroOcorrencia.funcionarioSelecionado === -1
          ? this.usuarioLogado.id
          : this.filtroOcorrencia.funcionarioSelecionado,
        this.filtroOcorrencia.integradorSelecionado,
        this.filtroOcorrencia.tipoSelecionado,
        this.filtroOcorrencia.pInicio,
        this.filtroOcorrencia.pFim,
        this.filtroOcorrencia.idOcorrencia,
        this.filtroOcorrencia.idFornecedor,
        this.filtroOcorrencia.setorSelecionado,
        this.filtroOcorrencia.notaFiscal,
        this.filtroOcorrencia.vendedorSelecionado,
        this.filtroOcorrencia.prioridade,
        this.filtroOcorrencia.etapaOcorrencia
      )
      .subscribe(
        (res: { itens: Ocorrencia[]; total: number }) => {
          this.ocorrencias = res.itens;
          this.paginacao.total = res.total;
          this.carregandoService.esconde("buscarOcorrencias");
        },
        (err: Error) => {
          this.carregandoService.esconde("buscarOcorrencias");
          this.notificacaoService.erro(err);
        }
      );
  }

  abrirLancamentoOcorrencia(idOcorrencia: number) {
    this.router.navigate(["controle-ocorrencia/lancamento"], {
      state: {
        veioDoModal: false,
        idOcorrencia,
      },
    });
  }

  editarOcorrencia(idOcorrencia: number) {
    this.router.navigate(["controle-ocorrencia/editar", idOcorrencia]);
  }

  exportar() {
    this.carregandoService.mostra("exportar");
    this.ocorrenciaService
      .exportarConsultaOcorrencias(
        this.paginacao.paginaAtual,
        this.filtroOcorrencia.itensPorPagina,
        this.filtroOcorrencia.campoOrdenacao,
        this.filtroOcorrencia.ordenarDesc ? "desc" : "asc",
        this.filtroOcorrencia.idCupom,
        this.filtroOcorrencia.periodoSelecionado,
        this.filtroOcorrencia.statusSelecionados,
        this.filtroOcorrencia.funcionarioSelecionado === 0
          ? undefined
          : this.filtroOcorrencia.funcionarioSelecionado === -1
          ? this.usuarioLogado.id
          : this.filtroOcorrencia.funcionarioSelecionado,
        this.filtroOcorrencia.integradorSelecionado,
        this.filtroOcorrencia.tipoSelecionado,
        this.filtroOcorrencia.pInicio,
        this.filtroOcorrencia.pFim,
        this.filtroOcorrencia.idOcorrencia,
        this.filtroOcorrencia.idFornecedor,
        this.filtroOcorrencia.setorSelecionado,
        this.filtroOcorrencia.notaFiscal,
        this.filtroOcorrencia.vendedorSelecionado,
        this.filtroOcorrencia.prioridade,
        this.filtroOcorrencia.etapaOcorrencia
      )
      .subscribe(
        (arq) => {
          this.utilitarioService.saveBlob(arq, "ControleDeOcorrencias.xlsx");
          this.carregandoService.esconde("exportar");
        },
        (err) => {
          this.carregandoService.esconde("exportar");
          this.notificacaoService.erro(err);
        }
      );
  }

  // 0 - faturamento | 1- fiscal
  imprimirNota(idCupom, tipoNota) {
    this.carregandoService.mostra("imprimirNota");

    this.notaFiscalService.imprimirNotaPorIdCupom(idCupom, tipoNota).subscribe(
      (resp) => {
        this.utilitarioService.openBlob(resp);

        this.carregandoService.esconde("imprimirNota");
      },
      (erro) => {
        const reader = new FileReader();

        // This fires after the blob has been read/loaded.
        reader.addEventListener("loadend", (e) => {
          const text = e.srcElement["result"];
          this.carregandoService.esconde("imprimirNota");
          this.notificacaoService.erro(text);
        });

        // Start reading the blob as text.
        reader.readAsText(erro.error);
      }
    );
  }

  notasFiscais(idCupom) {
    const largura = Number($("body").width());
    const dialogRef = this.dialog.open(NotaFiscalPedidoModalComponent, {
      width: largura > 830 ? "800px" : $("body").width().toString() + "px",
      data: {
        idCupom: idCupom,
        filtraOcorrencia: true,
      },
      panelClass: "modal-card",
    });
  }

  ngAfterViewInit() {
    this.sincronizaBarraRolagem();
  }

  sincronizaBarraRolagem() {
    const scrollSyncWrapperTop = document.querySelector(".scroll-sync-wrapper-top");
    const scrollSyncWrapper = document.querySelector(".scroll-sync-wrapper");

    if (scrollSyncWrapperTop && scrollSyncWrapper) {
      let isWrapperTopSyncing = false;
      let isWrapperSyncing = false;

      scrollSyncWrapperTop.addEventListener("scroll", () => {
        if (!isWrapperSyncing) {
          isWrapperTopSyncing = true;
          scrollSyncWrapper.scrollLeft = scrollSyncWrapperTop.scrollLeft;
        }

        isWrapperSyncing = false;
      });

      scrollSyncWrapper.addEventListener("scroll", () => {
        if (!isWrapperTopSyncing) {
          isWrapperSyncing = true;
          scrollSyncWrapperTop.scrollLeft = scrollSyncWrapper.scrollLeft;
        }

        isWrapperTopSyncing = false;
      });
    }
  }
}
